const reportsRoute = {
	name: 'report-template',
	path: 'report-template',
	meta: {
		title: 'Reportes',
	},
	component: () => import('@/pages/configuration/report-template'),
};

export default reportsRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/reports/index.js